export const isPathMatch = (paths?: Array<string>, pageUri?: string) => {
  if (!paths || paths.length < 1 || !pageUri) {
    return false
  }
  return paths.some(path => {
    const isExactMatch = pageUri === path
    const isPartialMatchAllowed = path.endsWith('/') && path.length > 1
    const isStartPartialMatchRegex = new RegExp(`^${path.slice(0, -1)}[?/].*`)
    const isStartPartialMatch = isPartialMatchAllowed && isStartPartialMatchRegex.test(pageUri)
    return isExactMatch || isStartPartialMatch
  })
}
